import ModalystOrderPaymentCompleteModal from './ModalystOrderPaymentCompleteModal'

export default ModalystOrderPaymentCompleteModal
